module.exports = __webpack_public_path__ + "img/solution-farmer-cooperation.1aec80d6.svg";